export const useRelativePath = () => {
  if ([
    `mixpanel.com`,
    `eu.mixpanel.com`,
    `in.mixpanel.com`,
    `staging-1.mixpanel.com`,
    `staging-2.mixpanel.com`,
    `staging-eu-1.mixpanel.com`,
    `staging-eu-2.mixpanel.com`,
    `staging-in-1.mixpanel.com`,
    `staging-in-2.mixpanel.com`,
    // Dashboard digests, etc.
    `web-internal`,
  ].includes(window.location.hostname)) {
    return true;
  }
  // devboxes
  return window.location.hostname.endsWith(`mixpanel.org`);
}
